import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';

// 样式文件引入
import '@/assets/css/reset.css';

// 动画文件引入
import '@/assets/css/animate.css';

// rem适配
import '@/assets/js/flex-lib.min.js';

// 正则表达式
import myRegExp from '@/assets/js/RegExp';

// 引用API文件
import api from './api/api';

// 引入cookie封装
import cookie from './assets/js/cookie/cookie';
import storage from './assets/js/storeStorage/storeStorage';

// 引入机场三字码转换
import changeAirport from './assets/js/airport/changeAirport';

// 引入AES加密
import AES from '@/assets/js/encrypt/AES';

// 引入Vant
import 'vant/lib/index.css';
import Vant from 'vant';
Vue.use(Vant);

// 引入NutUI(尽量按需加载)
// import NutUI from '@nutui/nutui';
// import '@nutui/nutui/dist/nutui.css';
// NutUI.install(Vue, NutUI);

// 将API方法绑定到全局
Vue.prototype.$api = api;
Vue.prototype.$reg = myRegExp;
Vue.prototype.$cookie = cookie;
Vue.prototype.$storage = storage;
Vue.prototype.$changeAirport = changeAirport;
Vue.prototype.$AES = AES;

Vue.config.productionTip = false;

// 引入moment.js
import moment from 'moment';

Vue.filter('formatDateMon', (time: string) => {
  return moment(time).format('YYYY-MM');
});

Vue.filter('formatDateDay', (time: string) => {
  return moment(time).format('YYYY-MM-DD');
});

Vue.filter('formatDateMin', (time: string) => {
  return moment(time).format('YYYY-MM-DD HH:mm');
});

Vue.filter('formatDateSec', (time: string) => {
  return moment(time).format('YYYY-MM-DD HH:mm:ss');
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
